import React, { useMemo } from 'react';
import { Typography } from '@mui/material';
import DOMPurify from 'dompurify';
import './RichTextEditor.css';

type Props = {
    content?: string | null;
};

// What the Quill toolbar can produce (see RTE in CampaignNotesCell): `style` carries colours and
// `class` carries Quill's indent and size classes.
const allowedTags = ['p', 'br', 'strong', 'em', 'u', 's', 'sub', 'sup', 'code', 'span'];
const allowedAttr = ['style', 'class'];

/**
 * Renders stored rich text as HTML, so it is always sanitised here: the API accepts any string for
 * the fields this shows (campaign internal notes), and callers must not have to remember to.
 */
const RichTextEditorPreview: React.FC<Props> = ({ content }) => {
    const htmlContentProps = useMemo(
        () => ({
            __html: DOMPurify.sanitize(content ?? '', {
                ALLOWED_TAGS: allowedTags,
                ALLOWED_ATTR: allowedAttr,
            }),
        }),
        [content],
    );
    return (
        <Typography
            component="div"
            variant="caption"
            className="rte-preview"
            dangerouslySetInnerHTML={htmlContentProps}
        />
    );
};

export default RichTextEditorPreview;
